import { CreateServiceOfficeStatementBody } from '../app-types/service-office-statement';
import { CreateApiServiceOfficeStatementBody } from '../api-types/service-office-statement.api';
import { formatDateToISOString } from '../../shared/helpers/date.func';

/**
 * Transforms an app-specific CreateServiceOfficeStatementBody object into a CreateApiServiceOfficeStatementBody.
 * @description This function maps properties of the CreateServiceOfficeStatementBody to the API model.
 * @returns CreateApiServiceOfficeStatementBody.
 */
export const transformCreateServiceOfficeStatementToApiCreateServiceOfficeStatementBody = (
	input: CreateServiceOfficeStatementBody,
) => {
	const output: CreateApiServiceOfficeStatementBody = {
		clientId: input.clientId,
		startOfCare: input.startOfCare,
		sponsorId: input.sponsorId,
		legalFoundationId: input.legalFoundationId,
		careRelatedHandycapId: input.careRelatedHandycapId,
		socialDataProtectionInfo: input.socialDataProtectionInfo,
		documentIds: input.documentIds,
		hasBeenClarified: input.hasBeenClarified,
		clarifiedAt: formatDateToISOString(input.clarifiedAt),
		typeOfClarification: input.typeOfClarification,
	};
	return output;
};
